<div class="card">

    <!-- <div class="border-0">
        

    </div> -->
    <div class="table-responsive" data-toggle="list" >
        <table class="table" id="attendance">
            <col style="width:15%">
            <col style="width:40%">
            <col style="width:25%">
            <thead class="thead-light">
                <tr>
                    <th colspan="6">
                        <div><h2 class="mb-0 d-inline">Students' List </h2><button style="float:right" class="add-item-btn" title="Export" (click)="export()" ><i
                            class='fas fileicons'>&#xf381;</i> Export</button></div>
                    </th>
                 
                </tr>
         
            
                <tr>
                    <th scope="col" class="">S. No</th>
                    <th>Name</th>
                    <th scope="col" class="">Email</th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                 
                </tr>
            </thead>
            <tbody class="list">
                <!-- <div   *ngFor="let student of students; let i=index;"> -->
                <tr *ngFor="let student of students | paginate: {  itemsPerPage: itemsPerPage , currentPage: p, totalItems: totalItems}; let i = index">
                    <td class="sno">
                    {{((p - 1) * itemsPerPage) + (i + 1)}}  </td>
                    <td>{{student.name}}</td>
                    <td class="email">
                        {{student.email}}  </td>
                   <td></td>
                   <td></td>
                   <td></td>
                </tr>
                <!-- </div> -->
            </tbody>
        
          
        </table>
        <pagination-controls (pageChange)="getPage(p = $event)" style="text-align: center;"></pagination-controls>
        <!-- <ul>
            <li *ngFor="let student of students | paginate: {  itemsPerPage: itemsPerPage , currentPage: p, totalItems: totalItems}">{{student.email}} </li>
        </ul>
        
        <pagination-controls (pageChange)="getPage(p = $event)"></pagination-controls> -->
    </div>


</div>